import React, { useEffect, useState } from 'react'
import { Card, Container, Group, Indicator, ScrollArea, SimpleGrid, Text } from '@mantine/core'
import BarChart from '../components/charts/BarChart'
import SeriesBarChart from '../components/charts/SeriesBarChart'
import DougnotChart from '../components/charts/DougnotChart'
import SeriesLineChart from '../components/charts/SeriesLineChart'
import DynamicLineChart from '../components/charts/DynamicLineChart'
import LoaderComponent from '../components/loader/LoaderComponent'
import { formatString } from '../utils/reusedfunctions'
import { Link } from 'react-router-dom'
import '../index.css'


const DashBoardPage = () => {
    const [totalCount,    setTotalCount]    = useState({})
    const [graphData,     setGraphData]     = useState([])
    const [machineStatus, setMachineStatus] = useState([])

    useEffect(() => {
        const wsProtocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
        const url = `${wsProtocol}//${window.location.host}/dashboardSocket/?user_id=${window.localStorage.getItem('userid')}`;
        const socket = new WebSocket(url);

        socket.onopen = () => {
            socket.send(JSON.stringify({
                message:   'CONNECTED',
                user_id:   window.localStorage.getItem('userid'),
                user_name: window.localStorage.getItem('username'),
            }));
        };

        socket.onmessage = (event) => {
            const b = JSON.parse(event.data);

            setTotalCount(b.total_count_result || {});
            setGraphData(b.dashboard_cards?.resultant_data || []);

            const active   = [];
            const inactive = [];
            b.machine_status?.forEach((m) => {
                m.Machines_status === 'Inactive' ? inactive.push(m) : active.push(m);
            });
            setMachineStatus([...active, ...inactive]);
        };

        return () => socket.close();
    }, []);

    const hasLoaded = Object.entries(totalCount).length > 0;

    return (
        <Container mt="0.3rem" fluid>
            <Container fluid ml={10}>
                {!hasLoaded ? <LoaderComponent /> : (
                    <>
                        {/* ── Row 1: summary count cards ── */}
                        <SimpleGrid
                            cols={3}
                            breakpoints={[
                                { maxWidth: 'md', cols: 2 },
                                { maxWidth: 'sm', cols: 1 },
                            ]}
                        >
                            {Object.entries(totalCount).map(([key, value]) => (
                                <Card padding="lg" shadow="xs" radius="md" key={key}>
                                    <Group>
                                        <Text size="md" className="subcardHeading" style={{ marginBottom: '0.5rem' }}>
                                            {formatString(key)}
                                        </Text>
                                        {key === 'Active Machines' && <Indicator color="green" mt="-5px" />}
                                        {key === 'Inactive Machines' && <Indicator color="red" mt="-5px" />}
                                    </Group>
                                    <Text color="var(--color-text)" weight={400} className="detailsCardcol1">
                                        {value}
                                    </Text>
                                </Card>
                            ))}
                        </SimpleGrid>

                        {/* ── Row 2: machine status list + optional chart cards ── */}
                        <SimpleGrid
                            cols={graphData.length > 0 ? 3 : 1}
                            mt="lg"
                            breakpoints={[
                                { maxWidth: 'md', cols: 2 },
                                { maxWidth: 'sm', cols: 1 },
                            ]}
                        >
                            {/* Machine Status card */}
                            <Card padding="lg" shadow="xs" radius="md">
                                <Text size="md" className="subcardHeading" mb="sm">
                                    Machine Status
                                </Text>
                                <ScrollArea>
                                    <SimpleGrid cols={1} spacing="xs" pl={4}>
                                        {machineStatus.map((machine) => {
                                            const isActive = machine.Machines_status === 'Active';
                                            return (
                                                <Group key={machine.node_id} spacing="xs" align="center">
                                                    <Indicator
                                                        color={isActive ? 'green' : 'red'}
                                                        size={10}
                                                        position="middle-start"
                                                        style={{ marginRight: 4 }}
                                                    />
                                                    <Text
                                                        color="var(--color-text)"
                                                        weight={400}
                                                        className="detailsCardcol1"
                                                    >
                                                        <Link
                                                            id="dashboardlink"
                                                            to={`/app/submachine/${machine.Machine_name}/${machine.node_id}`}
                                                        >
                                                            {formatString(machine.Machine_name)}
                                                        </Link>
                                                    </Text>
                                                </Group>
                                            );
                                        })}
                                    </SimpleGrid>
                                </ScrollArea>
                            </Card>

                            {/* Chart cards (only rendered if backend sends them) */}
                            {graphData.map((card, i) => {
                                if (card.card === 'Bar') {
                                    return card.ledger?.length > 1
                                        ? <SeriesBarChart key={i} data={card} />
                                        : <BarChart key={i} data={card} />;
                                }
                                if (card.card === 'Pie') return <DougnotChart key={i} data={card} />;
                                if (card.card === 'Line') {
                                    return card.ledger?.length > 1
                                        ? <SeriesLineChart key={i} data={card} />
                                        : <DynamicLineChart key={i} data={card} />;
                                }
                                return null;
                            })}
                        </SimpleGrid>
                    </>
                )}
            </Container>
        </Container>
    );
};

export default DashBoardPage;
